<template>
  <v-app style="background-color: #f8f9fb">
    <v-container
      style="background-color: #eee"
      id="config-relatorios-seguro"
      fluid
      tag="section"
    >
      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-shield-cog"
            title="Configuração Relatórios Seguro"
            color="green"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-4"
          >
            <v-card class="pa-4 mx-4 filtro-config-seguro" elevation="0">
              <v-row dense>
                <v-col cols="12" sm="6" md="3">
                  <span>Empresa</span>
                  <v-select
                    v-model="filtros.empresa"
                    :items="empresas"
                    item-text="text"
                    item-value="value"
                    label="Empresa"
                    dense
                    solo-inverted
                    @change="handleEmpresaChange"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="3">
                  <span>Relatório</span>
                  <v-select
                    v-model="filtros.tipoRelatorio"
                    :items="tiposRelatorio"
                    item-text="text"
                    item-value="value"
                    label="Relatório"
                    dense
                    solo-inverted
                    @change="carregarPlanos"
                  ></v-select>
                </v-col>

                <v-col v-if="showContratoSeguro" cols="12" sm="6" md="3">
                  <span>Contrato</span>
                  <v-select
                    v-model="filtros.contrato"
                    :items="contratos"
                    item-text="text"
                    item-value="value"
                    label="Contrato"
                    dense
                    solo-inverted
                    @change="carregarPlanos"
                  ></v-select>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="pa-4 mx-4 mt-4" elevation="0" :class="{ 'editing-mode': form.id }">
              <v-alert v-if="mensagem" :type="mensagemTipo" dense outlined>
                {{ mensagem }}
              </v-alert>

              <v-row dense align="start">
                <v-col cols="12" md="5">
                  <div class="d-flex align-center justify-space-between mb-1">
                    <span>Tipo de contrato iVertex</span>
                    <v-chip
                      v-if="!form.id && !loadingTipos"
                      x-small
                      :color="tiposContratoDisponiveis.length > 0 ? 'green' : 'orange'"
                      dark
                    >
                      {{ tiposContratoDisponiveis.length }} disponível(is)
                    </v-chip>
                  </div>
                  <v-autocomplete
                    v-model="form.tipoContrato"
                    :items="tiposContratoDisponiveis"
                    item-text="nomeTipoContrato"
                    return-object
                    label="Tipo de contrato"
                    dense
                    solo-inverted
                    :loading="loadingTipos"
                    :no-data-text="form.id ? 'Nenhum tipo de contrato encontrado' : 'Todos os tipos já estão cadastrados'"
                    :hint="!form.id && tiposContratoDisponiveis.length === 0 ? 'Todos os tipos de contrato já possuem planos ativos' : ''"
                    persistent-hint
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                  <span>Plano</span>
                  <v-text-field
                    v-model="form.plano"
                    label="Plano"
                    dense
                    solo-inverted
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="2">
                  <span>Capital</span>
                  <v-text-field
                    v-model="form.capital"
                    label="Capital"
                    dense
                    solo-inverted
                    :disabled="filtros.tipoRelatorio !== 'vg'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="1">
                  <span>Ativo</span>
                  <v-switch v-model="form.ativo" dense inset></v-switch>
                </v-col>

                <v-col cols="12" md="2" class="d-flex justify-end align-center" style="gap: 8px;">
                  <v-btn
                    v-if="form.id"
                    outlined
                    small
                    color="grey darken-1"
                    height="36"
                    class="text-capitalize"
                    @click="cancelarEdicao"
                  >
                    <v-icon left small>mdi-close</v-icon>
                    Cancelar
                  </v-btn>
                  <v-btn
                    color="primary"
                    small
                    height="36"
                    class="text-capitalize font-weight-bold"
                    :loading="saving"
                    @click="salvar"
                  >
                    <v-icon left small>mdi-content-save</v-icon>
                    {{ form.id ? 'Atualizar' : 'Salvar' }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>

            <v-card class="pa-4 mx-4 mt-4" elevation="0">
              <v-data-table
                :headers="headers"
                :items="planos"
                :loading="loadingPlanos"
                dense
                class="elevation-0 table"
                no-data-text="Nenhuma configuração encontrada"
              >
                <template v-slot:item.ativo="{ item }">
                  <v-chip small :color="item.ativo ? 'green' : 'grey'" dark>
                    {{ item.ativo ? "Ativo" : "Inativo" }}
                  </v-chip>
                </template>

                <template v-slot:item.acoes="{ item }">
                  <v-btn icon small title="Editar" @click="editar(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    :title="item.ativo ? 'Inativar' : 'Ativar'"
                    @click="alterarStatus(item)"
                  >
                    <v-icon small>
                      {{
                        item.ativo
                          ? "mdi-toggle-switch"
                          : "mdi-toggle-switch-off"
                      }}
                    </v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card>
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import GestaoCarteiraService from "../../services/gestaoCarteira";

export default {
  name: "ConfigRelatoriosSeguro",
  data() {
    return {
      filtros: {
        empresa: "PREVIDA",
        tipoRelatorio: "vg",
        contrato: 1,
      },
      form: {
        id: null,
        tipoContrato: null,
        plano: "",
        capital: "",
        ativo: true,
      },
      loadingTipos: false,
      loadingPlanos: false,
      saving: false,
      mensagem: "",
      mensagemTipo: "success",
      mensagemTimeout: null,
      empresas: [
        {
          text: "CEMITERIO PREVIDA",
          value: "CEMITERIO PREVIDA",
          possuiDoisContratos: true,
          contratoPadrao: 1,
        },
        {
          text: "CEMITERIO PREVIDA SÃO MIGUEL",
          value: "CEMITERIO PREVIDA SÃO MIGUEL",
          possuiDoisContratos: false,
          contratoPadrao: 1,
        },
        {
          text: "MEMORIAL PARQUE MACEIÓ",
          value: "MEMORIAL PARQUE MACEIÓ",
          possuiDoisContratos: false,
          contratoPadrao: 1,
        },
        {
          text: "PARQUE DO AGRESTE",
          value: "PARQUE DO AGRESTE",
          possuiDoisContratos: false,
          contratoPadrao: 1,
        },
        {
          text: "PREVIDA",
          value: "PREVIDA",
          possuiDoisContratos: true,
          contratoPadrao: 1,
        },
        {
          text: "PARQUE DAS FLORES",
          value: "PARQUE DAS FLORES",
          possuiDoisContratos: true,
          contratoPadrao: 1,
        },
      ],
      tiposRelatorio: [
        { text: "VG", value: "vg" },
        { text: "Remissivo", value: "remissivo" },
      ],
      contratos: [
        { text: "FAIXA ETÁRIA (NOVO)", value: 1 },
        { text: "TIPO DE CONTRATO", value: 2 },
      ],
      tiposContrato: [],
      planos: [],
      headers: [
        { text: "ID Tipo", value: "idTipoContrato" },
        { text: "Tipo de Contrato", value: "nomeTipoContrato" },
        { text: "Plano", value: "plano" },
        { text: "Capital", value: "capital" },
        { text: "Status", value: "ativo" },
        { text: "Ações", value: "acoes", sortable: false, align: "center" },
      ],
    };
  },
  mounted() {
    this.filtros.contrato = this.contratoPadraoSeguro;
    this.carregarTudo();
  },
  beforeDestroy() {
    if (this.mensagemTimeout) {
      clearTimeout(this.mensagemTimeout);
    }
  },
  computed: {
    empresaSelecionada() {
      return this.empresas.find(
        (empresa) => empresa.value === this.filtros.empresa,
      );
    },
    showContratoSeguro() {
      return Boolean(
        this.empresaSelecionada && this.empresaSelecionada.possuiDoisContratos,
      );
    },
    contratoPadraoSeguro() {
      return this.empresaSelecionada && this.empresaSelecionada.contratoPadrao
        ? this.empresaSelecionada.contratoPadrao
        : 1;
    },
    tiposContratoDisponiveis() {
      // Se está editando, retorna todos os tipos
      if (this.form.id) {
        return this.tiposContrato;
      }

      // Filtra apenas tipos de contrato que não estão ativos na lista de planos
      const idsAtivos = this.planos
        .filter(plano => plano.ativo)
        .map(plano => plano.idTipoContrato);

      return this.tiposContrato.filter(
        tipo => !idsAtivos.includes(tipo.idTipoContrato)
      );
    },
  },
  methods: {
    formVazio() {
      return {
        id: null,
        tipoContrato: null,
        plano: "",
        capital: "",
        ativo: true,
      };
    },
    carregarTudo() {
      this.carregarTiposContrato();
      this.carregarPlanos();
    },
    handleEmpresaChange() {
      this.filtros.contrato = this.contratoPadraoSeguro;
      this.form = this.formVazio();
      this.carregarTudo();
    },
    carregarTiposContrato() {
      if (!this.filtros.empresa) return;
      this.loadingTipos = true;
      GestaoCarteiraService.listarTiposContratoSeguro(this.filtros.empresa)
        .then((response) => {
          this.tiposContrato = Array.isArray(response.data)
            ? response.data
            : [];
        })
        .catch(() =>
          this.exibirMensagem("Erro ao carregar tipos de contrato.", "error"),
        )
        .finally(() => {
          this.loadingTipos = false;
        });
    },
    carregarPlanos() {
      if (
        !this.filtros.empresa ||
        !this.filtros.tipoRelatorio ||
        !this.filtros.contrato
      )
        return;
      this.loadingPlanos = true;
      GestaoCarteiraService.listarPlanosSeguro({
        empresa: this.filtros.empresa,
        "tipo-relatorio": this.filtros.tipoRelatorio,
        contrato: this.filtros.contrato,
      })
        .then((response) => {
          this.planos = Array.isArray(response.data) ? response.data : [];
        })
        .catch(() =>
          this.exibirMensagem("Erro ao carregar configurações.", "error"),
        )
        .finally(() => {
          this.loadingPlanos = false;
        });
    },
    salvar() {
      if (!this.form.tipoContrato || !this.form.plano) {
        this.exibirMensagem("Informe o tipo de contrato e o plano.", "error");
        return;
      }
      if (this.filtros.tipoRelatorio === "vg" && !this.form.capital) {
        this.exibirMensagem("Informe o capital para VG.", "error");
        return;
      }

      // Validação adicional: verifica se já existe um plano ativo com este tipo de contrato
      if (!this.form.id) {
        const jaExiste = this.planos.some(
          plano => 
            plano.ativo && 
            plano.idTipoContrato === this.form.tipoContrato.idTipoContrato
        );
        
        if (jaExiste) {
          this.exibirMensagem(
            "Já existe um plano ativo para este tipo de contrato. Inative o plano existente antes de cadastrar um novo.",
            "error"
          );
          return;
        }
      }

      const payload = {
        id: this.form.id,
        empresa: this.filtros.empresa,
        tipoRelatorio: this.filtros.tipoRelatorio,
        contratoId: this.filtros.contrato,
        idTipoContrato: this.form.tipoContrato.idTipoContrato,
        nomeTipoContrato: this.form.tipoContrato.nomeTipoContrato,
        plano: this.form.plano,
        capital: this.filtros.tipoRelatorio === "vg" ? this.form.capital : null,
        ativo: this.form.ativo,
      };

      this.saving = true;
      const isEdicao = !!this.form.id;
      GestaoCarteiraService.salvarPlanoSeguro(payload)
        .then(() => {
          this.form = this.formVazio();
          this.carregarPlanos();
        })
        .catch((error) => {
          const msg =
            error.response && error.response.data && error.response.data.erro;
          this.exibirMensagem(msg || "Erro ao salvar configuração.", "error");
        })
        .finally(() => {
          this.saving = false;
        });
    },
    editar(item) {
      this.form = {
        id: item.id,
        tipoContrato: {
          idTipoContrato: item.idTipoContrato,
          nomeTipoContrato: item.nomeTipoContrato,
        },
        plano: item.plano,
        capital: item.capital,
        ativo: item.ativo,
      };
    },
    cancelarEdicao() {
      this.form = this.formVazio();
    },
    alterarStatus(item) {
      const novoStatus = !item.ativo;
      GestaoCarteiraService.alterarStatusPlanoSeguro(item.id, novoStatus)
        .then(() => {
          this.exibirMensagem(
            `Configuração ${novoStatus ? 'ativada' : 'inativada'} com sucesso!`,
            "success"
          );
          this.carregarPlanos();
        })
        .catch(() => this.exibirMensagem("Erro ao alterar status.", "error"));
    },
    exibirMensagem(texto, tipo = "success") {
      this.mensagem = texto;
      this.mensagemTipo = tipo;
      
      // Limpa a mensagem após 5 segundos
      if (this.mensagemTimeout) {
        clearTimeout(this.mensagemTimeout);
      }
      this.mensagemTimeout = setTimeout(() => {
        this.mensagem = "";
      }, 3000);
    },
  },
};
</script>

<style scoped>
.filtro-config-seguro span,
.v-card span {
  display: block;
  margin-bottom: 4px;
  color: #4f5b62;
  font-size: 12px;
  font-weight: 600;
}

.d-flex span {
  display: inline-block;
  margin-bottom: 0;
}

.table ::v-deep th,
.table ::v-deep td {
  font-size: 12px !important;
}

.editing-mode {
  border-left: 4px solid #2196f3 !important;
  background-color: #f5f9ff !important;
}
</style>
